module.exports = {
	"WORKSPACE": {
		"PAGE_TITLE": "Workspace - Mobile Carwash Service",
		"CLIENT_NAME": "Workspace",
		"CLIENT_PREFIX": "WKS",
		"PAYMENT_TYPE": "PRE",
		"LOGO_PATH": "./workspace/logo.svg"
	},
	"FLEETPLUS": {
		"PAGE_TITLE": "FleetPlus - Mobile Carwash Service",
		"CLIENT_NAME": "FleetPlus",
		"CLIENT_PREFIX": "FP",
		"PAYMENT_TYPE": "PRE",
		"LOGO_PATH": "./fleetplus/logo.svg"
	},
	"MCCARROLLS": {
		"PAGE_TITLE": "Maserati McCarroll's - Mobile Carwash Service",
		"CLIENT_NAME": "McCarrolls",
		"CLIENT_PREFIX": "MC",
		"PAYMENT_TYPE": "PRE",
		"FAVICON_PATH": "./mccarrolls/favicon.ico",
		"AVAILABLE_WASH_TYPES": [
			"SPECTO",
			"TODO IMPLEMENT"
		],
		"LOGO_PATH": "./mccarrolls/logo.png",
		"ALLOWED_WASH_TYPES": [
			"SPECTO"
		]
	},
	"CARPARKS": {
		"PAGE_TITLE": "WipeHero - Carpark Wash Service",
		"CLIENT_NAME": "carparks",
		"CLIENT_PREFIX": "CP",
		"PAYMENT_TYPE": "POST",
		"LOGO_PATH": "./carparks/icon.png"
	},
	"DOMAIN": {
		"PAGE_TITLE": "WipeHero - Carpark Wash Service",
		"CLIENT_NAME": "carparkDomain",
		"CLIENT_PREFIX": "CPDOM",
		"PAYMENT_TYPE": "POST",
		"LOGO_PATH": "/carparks/domain/logo.png",
		"LOCAL_LOGO_PATH": "/carparks/domain/local_logo.png",
		"ALLOWED_WASH_TYPES": [
			"OUTIE",
			"SPECTO",
			"FULLO"
		]
	},
	"SPLEND": {
		"PAGE_TITLE": "WipeHero - Splend",
		"CLIENT_NAME": "Splend",
		"CLIENT_ID": "10066",
		"CLIENT_PREFIX": "SPLND",
		"PAYMENT_TYPE": "POST",
		"LOGO_PATH": "/splend/logo.png",
		"LOCAL_LOGO_PATH": "/splend/local_logo.png",
		"ALLOWED_WASH_TYPES": [
			"OUTIE",
			"FULLO"
		]
	},
	"SMS": {
		"PAGE_TITLE": "WipeHero - SMS Booking Payment",
		"PAYMENT_TYPE": "PAYMENT_ONLY"
	},
	"WASH_TYPES": [
		{
			"name": "OUTIE",
			"displayName": "Silver",
			"points": [
				"Quick Exterior Hand Wash",
				"Tyre Shine & Rim Wipedown",
				"Windows Cleaned (Outside Only)"
			]
		},
		{
			"name": "FULLO",
			"displayName": "Gold",
			"points": [
				"Quick Exterior Hand Wash",
				"Tyre Shine & Rim Wipedown",
				"Windows Cleaned (Inside + Outside)",
				"Interior & Trunk Vacuum",
				"Inside Wipedown"
			]
		},
		{
			"name": "SPECTO",
			"displayName": "Platinum",
			"points": [
				"Detailed Exterior Hand Wash",
				"Tyre Shine & Rim Clean",
				"Windows Cleaned (Inside + Outside)",
				"Thorough Interior & Trunk Vacuum",
				"Inside Wipedown",
				"Bug & Tar Removal",
				"Complete Wax For Protect & Shine"
			]
		}
	],
	"BOOKING_STEPS": {
		"PRE": [
			"carDetails",
			"washDetails",
			"preCustomerDetails",
			"creditcard",
			"preFinished"
		],
		"POST": [
			"postCustomerDetails",
			"washDetails",
			"postFinished"
		]
	},
	"THEME_DEFAULT": {
		"fontFamily": "Raleway, Nunito, sans-serif",
		"palette": {
			"primary1Color": "#77bc1f",
			"primary2Color": "#005b74",
			"accent1Color": "#77bc1f"
		},
		"datePicker": {
			"selectColor": "#77bc1f"
		}
	},
	"THEME_MCCARROLLS": {
		"fontFamily": "Raleway, Nunito, sans-serif",
		"palette": {
			"primary1Color": "#000B27",
			"primary2Color": "#005b74",
			"accent1Color": "#a8a8a8"
		},
		"datePicker": {
			"selectColor": "#000B27"
		}
	},
	"STRIPE": {
		"TEST_API_KEY": "pk_test_xvbtPJuP8Wy3tyPMpUfNnaqV",
		"PROD_API_KEY": "pk_live_vVUEFH0anLBNLkCbUaR2qVrE"
	},
	"GOOGLE": {
		"API_KEY": "AIzaSyDatYWCPqsw3XwgAT8yihp6RVph8fgHhFo"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/app/config.json
// module id = 687
// module chunks = 0